export default {
  actions: 'ações',
  action: 'ação',
  entity: 'entidade',
  event: 'evento',
  triggers: 'Automações',

  title_trigger: 'Automações',
  new_trigger: 'Nova Automação',

  title_integration: 'Integrações',
  new_integration: 'Nova Integração',

  modalTitle: 'Nova automação',
  modalTitle_edit: 'Editando automação',
  modalTitle_cloning: 'Clonando automação',

  when: 'Quando um(a) ',
  when_male: 'Quando um ',
  when_female: 'Quando uma ',

  'status.all': 'Todas',
  'status.request': 'Solicitação',
  'status.open': 'Aberta',
  'status.received': 'Recebida',
  'status.accept': 'Aceita',
  'status.refused': 'Recusada',
  'status.execution': 'Execução',
  'status.pause': 'Pausada',
  'status.unproductive': 'Improdutiva',
  'status.completed': 'Concluída',
  'status.pending': 'Pendente',
  'status.canceled': 'Cancelada',
  'status.approved': 'Aprovada',
  'status.disapproved': 'Reprovada',
  'status.resolved': 'Resolvida',
  'status.unresolved': 'Não Resolvida',
  'status.actionPlan': 'Plano de Ação',
  'status.request_plural': 'Solicitações',
  'status.open_plural': 'Abertas',
  'status.received_plural': 'Recebidas',
  'status.accept_plural': 'Aceitas',
  'status.refused_plural': 'Recusadas',
  'status.execution_plural': 'Execuções',
  'status.pause_plural': 'Pausadas',
  'status.unproductive_plural': 'Improdutivas',
  'status.completed_plural': 'Concluídas',
  'status.pending_plural': 'Pendentes',
  'status.canceled_plural': 'Canceladas',
  'status.approved_plural': 'Aprovadas',
  'status.disapproved_plural': 'Reprovadas',
  'status.resolved_plural': 'Resolvidas',
  'status.unresolved_plural': 'Não Resolvidas',
  'status.actionPlan_plural': 'Planos de Ação',
  'status.done': 'Concluídas',
  'status.ignored': 'Ignorada',
  'status.ignored_plural': 'Ignoradas',
  'status.inProgress': 'Em andamento',
  'status.inProgress_plural': 'Em andamento',
  'status.closing': 'Encerramento',
  'status.closing_plural': 'Encerramentos',
  'status.true': 'Sim',
  'status.false': 'Não',

  'relatives.relative_before': ' Antes do(a) ',
  'relatives.relative_moment': 'No exato momento do(a) ',
  'relatives.relative_after': ' Depois do(a) ',
  'relatives.relative_custom': 'Personalizar ',

  'periods.every_day': 'Todo dia',
  'periods.every_week': 'Toda semana',
  'periods.every_month': 'Todo mês',

  'fields.service_order.user_id': 'usuário',
  'fields.group_id': 'grupo responsável pela atividade',
  'fields.user.contract.group_id': 'grupo do usuário responsável',
  'fields.service_order.parent.user_id': 'usuário da atividade pai',
  'fields.user_id': 'usuário',
  'fields.service_order.opened': 'Atividade aberta',
  'fields.service_order.place_id': 'local',
  'fields.service_order.parent.place_id': 'local da atividade pai',
  'fields.non_compliance.opened': 'Atividade aberta',
  'fields.non_compliance.place_id': 'local',
  'fields.non_compliance.place.place_level_ids': 'nível de local',
  'fields.non_compliance_event.place.place_level_ids': 'nível de local',
  'fields.non_compliance_event.service_order.place_id': 'local',
  'fields.non_compliance_event.non_compliance.place_id': 'local',
  'fields.place_id': 'local',
  'fields.place.place_level_ids': 'nível de local',
  'fields.place.place_type_id': 'tipo de local',
  'fields.service_order.place.place_level_ids': 'nível de local',
  'fields.form_id': 'formulário',
  'fields.service_order.checklist_id': 'questionário',
  'fields.service_order.parent.checklist_id': 'questionário da atividade pai',
  'fields._event_service_order_reply_value': 'resposta da pergunta',
  'fields._form_reply_reply_value': 'resposta da pergunta',
  'fields.non_compliance.question.checklist_id': 'questionário',
  'fields.non_compliance_event.service_order.checklist_id': 'questionário',
  'fields.non_compliance_event.form_reply.form.checklist_id': 'questionário',
  'fields.form.checklist_id': 'questionário',
  'fields.checklist_id': 'questionário',
  'fields.status_id': 'status',
  'fields.tag_id': 'tag',
  'fields.service_order.tag_id': 'tag',
  'fields.non_compliance.question_id': 'pergunta',
  'fields.non_compliance.question.tag_ids': 'tag da pergunta',
  'fields.non_compliance_event.non_compliance.question_id': 'pergunta',
  'fields.non_compliance_event.non_compliance.question.tag_ids': 'tag da pergunta',
  'fields.non_compliance_event.type': 'tipo',
  'fields.non_compliance_event.form_reply.form_id': 'formulário',
  'fields.form_reply_id': 'resposta de formulário',

  'fields.place_lock.checklist_id': 'questionário',
  'fields.place_unlock.checklist_id': 'questionário',

  'fields.forms_non_compliance_event.non_compliance.place_id': 'Local da não conformidade',
  'fields.forms_non_compliance_event.reply.question.checklist_id': 'Questionário do formulário salvo',
  'fields.forms_non_compliance_event.non_compliance.question.name': 'Pergunta que gerou a não conformidade',
  'fields.forms_non_compliance_event.non_compliance.place.resume': 'Nome completo do destino',
  'fields.forms_non_compliance_event.non_compliance.place.name': 'Nome do destino',

  'entities.undefined': '___',
  'entities.service_order': 'atividade',
  'entities.reply': 'resposta',
  'entities.event': 'evento',
  'entities.checklist': 'questionário',
  'entities.place': 'local',
  'entities.person': 'pessoa',
  'entities.fleet': 'frota',
  'entities.user': 'usuário',
  'entities.non_compliance': 'agrupamento de não conformidade',
  'entities.non_compliance_event': 'evento de uma não conformidade',
  'entities.forms_non_compliance_event': 'evento de uma não conformidade',
  'entities.form': 'formulário',
  'entities.form_reply': 'resposta de formulário',

  'events.undefined': '___',

  'events.save': 'criado ou atualizado',
  'events.save_female': 'criada ou atualizado',
  'events.insert': 'criado',
  'events.insert_female': 'criada',
  'events.upsert': 'criado ou atualizado',
  'events.upsert_female': 'criada ou atualizada',
  'events.update': 'atualizado',
  'events.update_female': 'atualizada',
  'events.delete': 'removido',
  'events.delete_female': 'removida',
  'events.reply': 'respondida',

  'events.relative_before': 'antes da ',
  'events.moment': 'No exato momento da ',
  'events.relative_after': 'depois da ',

  'actions.undefined': '___',
  'actions.insert_service_order': 'criar uma nova atividade',
  'actions.insert_service_orders': 'criar várias atividades',
  'actions.complete_service_orders': 'concluir as atividades abertas',
  'actions.complete_non_compliances': 'concluir as não conformidades abertas',
  'actions.schedule_insert_service_order': 'criar uma nova atividade no futuro',
  'actions.schedule_insert_service_orders': 'criar varias atividades no futuro',
  'actions.update_service_order_name': 'atualizar nome da atividade',
  'actions.insert_user': 'criar um novo usuário',
  'actions.insert_place': 'criar um novo local/pessoa',
  'actions.webhook': 'chamar a api externa',
  'actions.email': 'enviar um email',
  'actions.createNonCompliance': 'criar não conformidade',
  'actions.action': 'ação',
  'actions.update_service_order_user_or_group': 'atualizar usuário ou grupo da atividade',

  'actions.slack_channel_message': 'enviar uma mensagem no slack',
  'actions.slack_direct_message': 'enviar uma DM via slack',
  'actions.google_calendar_insert_event': 'criar um evento no calendar',
  'actions.d4sign_send_to_sing': 'enviar um documento',
  'actions.d4sign_attach_document': 'anexar um documento',
  'actions.d4sign_gen_pdf_and_send_to_sing': 'gerar PDF e enviar',
  'actions.whatsapp_by_twilio': 'enviar um Whatsapp via Twilio',
  'actions.whatsapp_by_chat_pro': 'enviar um Whatsapp via ChatPro',
  'chatPro.dynamicNumber': 'dinâmico',
  'actions.sms_by_twilio': 'enviar um SMS via Twilio',

  'actions.place_lock': 'Desativar abertura de atividade para o local da não conformidade usando o questionário',
  'actions.set_availability_status': 'Alterar Status de Disponibilidade do Local',
  'actions.update_place': 'atualizar local da atividade',
  'actions.update_asset': 'atualizar local do ativo',

  'actions.update_status': 'atualizar status da atividade',
  'actions.update_parent_status': 'atualizar status da atividade pai',
  'actions.update_child_service_order': 'Atualizar Atividade',
  'actions.assign_tag': 'atribuir uma tag à atividade',
  'actions.remove_tag': 'remover a tag da atividade',

  'replyTypes.undefined': '___',
  'replyTypes.nonCompliance': 'não conformidade',
  'replyTypes.text': 'texto',
  'replyTypes.number': 'número',

  'webhook.addNew': 'Adicionar nova Header',
  'webhook.authorization': 'autorização',
  'webhook.workspace': 'workspace',

  'webhook.key': 'Chave',
  'webhook.value': 'Valor',

  name: 'Nome',
  readOnly: 'Somente leitura',
  enabled: 'Ativado',
  quantity: 'Quantidade',
  title: 'Automações',
  new: 'Nova Automação',
  bulkRegistration: 'Cadastro em massa',
  serviceOrdersCount: '{{count}} atividade',
  serviceOrdersCount_plural: '{{count}} atividades',
  dynamicFields: 'campos dinâmicos',
  content: 'Conteúdo',
  'fields.name': 'Nome',
  'fields.email': 'Email',
  'fields.profile': 'Perfil',
  'fields.checklist': 'Questionário*',
  'fields.destinationType': 'Tipo do destino',
  'fields.destination': 'Destino*',
  'fields.asset': 'Ativo',
  'fields.responsible': 'Responsável',
  'fields.scheduling': 'Agendamento',
  'fields.bond': 'Vínculo',
  'fields.type': 'Tipo',
  'fields.description': 'Descrição',
  'fields.metadata': 'Metadata',
  'fields.placePerson': 'Local/Pessoa*',
  'fields.schedulingDate': 'Data de agendamento',
  'fields.user': 'Usuário',
  updatePlaceData: 'Atualizar dados de local',
  fieldsWithoutValueNotChanged: 'Campos sem valor não serão alterados.',
  addPlaceTypeCondition: 'Para alterar os campos adicionais, adicione a condição de tipo de local na automação.',
  fillAtLeastOneField: 'Preencha algum campo.',
  'googleCalendar.eventTitle': 'Título do evento',
  'googleCalendar.description': 'Descrição',
  'googleCalendar.startsAt': 'Inicia em',
  'googleCalendar.duration': 'Duração do evento',
  'googleCalendar.durationOptions.15': 'Quinze minutos',
  'googleCalendar.durationOptions.30': 'Meia hora',
  'googleCalendar.durationOptions.60': 'Uma hora',
  'googleCalendar.durationOptions.90': 'Uma hora e meia',
  'googleCalendar.durationOptions.120': 'Duas horas',
  'googleCalendar.durationOptions.150': 'Duas horas e meia',
  'googleCalendar.durationOptions.180': 'Tres horas',
  'googleCalendar.durationOptions.210': 'Tres horas e meia',
  'googleCalendar.durationOptions.240': 'Quatro horas',
  'googleCalendar.emailReminder': 'Lembrete por email antes do evento (em minutos)',
  'd4sign.signers': 'signatários',
  'd4sign.signersRequired': 'Signatários*',
  'd4sign.documentName': 'Nome do documento',
  'd4sign.safe': 'Cofre*',
  'd4sign.folderOptional': 'Pasta (opicional)',
  'd4sign.document': 'Documento*',
  'd4sign.configureSigners': '+ Configurar Signatários',
  'd4sign.sequentialSignature': 'Usar assinatura em sequência (opicional)',
  'd4sign.emailRequired': 'Email*',
  'd4sign.actionRequired': 'Ação*',
  'd4sign.configureDocumentSending': 'Configurar envio de documentos',
  'd4sign.publicTokenForWebhook': 'Token público para webhook',
  'actions.originActivity': 'atividade origem',
  minimumOneRecord: 'Mínimo de 1 registro',
  selectAtLeastOneLevel: 'Selecione pelo menos um nivel',
  invalidPayload: 'Payload invalido',
  triggerCannotBeEdited: 'Gatilho não pode ser editado',
  'templates.onCompleteActivitySendEmail': 'Ao concluir uma atividade, envia um email',
  'templates.onCompleteActivityCallExternalApi': 'Ao concluir uma atividade, chama uma api externa',
  'templates.onCompleteActivitySendSlackMessage': 'Ao concluir uma atividade, envia uma mensagem no slack',
  'templates.onCompleteActivitySendDocumentToSign': 'Ao concluir uma atividade, envia um documento para ser assinado',
  'templates.onCompleteActivityAttachDocument': 'Ao concluir uma atividade, anexa um documento a origem',
  'templates.onCompleteActivitySendWhatsappTwilio': 'Ao concluir uma atividade, envia um whatsapp via twilio',
  'templates.onCompleteActivitySendSmsTwilio': 'Ao concluir uma atividade, envia um sms via twilio',
  'templates.onCompleteActivitySendWhatsappChatPro': 'Ao concluir uma atividade, envia um whatsapp via ChatPro',
  'templates.onCreateActivityCreateGoogleCalendarEvent': 'Ao criar uma atividade, cria um evento no google calendar',
  'templates.onCompleteActivityCreateNewActivity': 'Ao concluir uma atividade, cria uma nova atividade',
  'templates.onCreateActivityCreateAnotherActivity': 'Ao criar uma atividade, cria uma outra atividade',
  'templates.onCreateUserSendEmail': 'Ao criar uma usuário, envia um email',
  'templates.onCreateUserCallExternalApi': 'Ao criar uma usuário, chama uma api externa',
  'templates.onCreateUserCreateActivity': 'Ao criar uma usuário, cria uma atividade',
  'templates.onReplyFormSendEmail': 'Ao responder um formulário, envia um email',
  'templates.onReplyFormCallExternalApi': 'Ao responder um formulário, chama uma api externa',
  'templates.onReplyFormCreateActivity': 'Ao responder um formulário, cria uma atividade',
  'templates.onCreateNonComplianceInstanceSendEmail':
    'Ao criar uma nova ocorrência de uma não conformidade, envia um email',
  'templates.onCreateNonComplianceInstanceCallExternalApi':
    'Ao criar uma nova ocorrência de uma não conformidade, chama uma api externa',
  'templates.onCreateNonComplianceInstanceCreateActivity':
    'Ao criar uma nova ocorrência de uma não conformidade, cria uma atividade',
  'templates.onCreateFormsNonComplianceInstanceSendEmail':
    'Ao criar uma nova ocorrência de uma não conformidade, envia um email',
  'templates.onCreateFormsNonComplianceInstanceCallExternalApi':
    'Ao criar uma nova ocorrência de uma não conformidade, chama uma api externa',
  'templates.onCreateFormsNonComplianceInstanceCreateActivity':
    'Ao criar uma nova ocorrência de uma não conformidade, cria uma atividade',
  'templates.onCreatePlaceTypeSendEmail': 'Ao criar um(a) {{placeType}}, envia um email',
  'templates.onCreatePlaceTypeCallExternalApi': 'Ao criar um(a) {{placeType}}, chama uma api externa',
  'templates.onCreatePlaceTypeCreateActivity': 'Ao criar um(a) {{placeType}}, cria uma atividade',
  'templates.createCustomAutomation': 'Criar uma automação customizada',
  'templates.createNew': 'Criar nova',
  'templates.useTemplate': 'Usar template',
  'baseSentence.whenActivityCreated': 'Quando uma atividade for criada',
  'baseSentence.whenActivityUpdated': 'Quando uma atividade for atualizada',
  'baseSentence.whenActivityCreatedOrUpdated': 'Quando uma atividade for criado ou atualizado',
  'baseSentence.whenActivityStatusChanged': 'Quando uma atividade mudar de status',
  'baseSentence.whenActivityTagAssigned': 'Quando uma atividade receber uma tag',
  'baseSentence.whenActivityTagRemoved': 'Quando uma atividade perder a tag',
  'baseSentence.whenNonComplianceEventCreated': 'evento de uma não confromidade for criado',
  'baseSentence.whenNonComplianceGroupCreated': 'agrupamento de não confromidade for criado',
  'baseSentence.whenFormReplied': 'formulário for respondido',
  'baseSentence.whenReplyEdited': 'Quando uma resposta for editada',
  'baseSentence.whenPlaceTypeCreated': 'Quando um(a) {{placeType}} for criado',
  'baseSentence.whenPlaceTypeUpdated': 'Quando um(a) {{placeType}} for atualizado',
  'baseSentence.whenPlaceTypeCreatedOrUpdated': 'Quando um(a) {{placeType}} for criado ou atualizado',
  'completeServiceOrders.moreThanDays': 'há mais de {{days}} dias; ',
  'completeServiceOrders.withChecklists': ' com questionários {{checklists}}; ',
  'completeServiceOrders.shouldFireAutomations': 'Deve disparar automações.',
  'completeServiceOrders.configureAutomationBehavior': 'Configure o comportamento dessa automação.',
  'completeServiceOrders.moreThanDaysLabel': 'há mais de (em dias)',
  'completeServiceOrders.fireAutomations': 'Disparar automações.',
  'completeNonCompliances.moreThan': 'a mais de ',
  'completeNonCompliances.days': 'dias',
  'updateStatus.to': 'para ',
  'updateStatus.status': 'Status',
  'assignTag.to': 'com a tag ',
  'assignTag.tag': 'Tag',
  'updateServiceOrderUserOrGroup.user': 'usuário: {{name}}',
  'updateServiceOrderUserOrGroup.group': 'grupo: {{name}}',
  'updateServiceOrderUserOrGroup.groups': 'grupos',
  'updateServiceOrderUserOrGroup.withThe': 'com o',
  'updateServiceOrderUserOrGroup.withTheGroups': 'com os',
  'typeSelect.actionPlan': 'Plano de ação',
  'typeSelect.activity': 'Atividade',
  'fieldsSection.additionalFields': 'Campos adicionais',
  'fieldsSection.addFile': 'Adicionar Arquivo',
  'lockPlace.disablePlaceForNonCompliance': 'Desativar destino para não conformidade',
  'lockPlace.reasonRequired': 'Motivo*',
  'insertPlace.typeRequired': 'Tipo*',

  actionNotAllowedForTrigger: 'Esta ação não está disponível para este gatilho',
  'updateChildServiceOrder.nothingToChange': 'Selecione ao menos um dado para atualizar na atividade',
  'updateChildServiceOrder.actionLabel.current': 'Atualizar Atividade atual',
  'updateChildServiceOrder.actionLabel.child': 'Atualizar Atividade Filha',
  'updateChildServiceOrder.target': 'Qual atividade atualizar',
  'updateChildServiceOrder.target.current': 'Atividade atual (a que disparou a automação)',
  'updateChildServiceOrder.target.child': 'Atividade filha vinculada',
  'updateChildServiceOrder.targetHelp.current':
    'A própria atividade que disparou a automação é atualizada (nenhuma atividade nova é criada). Se alguém estiver com ela aberta na tela, o que for salvo depois pode sobrescrever a alteração feita pela automação.',
  'updateChildServiceOrder.targetHelp.child':
    'A atividade filha vinculada à atividade que disparou a automação é atualizada.',
  'updateChildServiceOrder.status': 'Status',
  'updateChildServiceOrder.fieldsHelpCurrent':
    'Só os campos adicionais preenchidos aqui são atualizados na atividade. Os demais campos adicionais dela são mantidos como estão.',
  'updateChildServiceOrder.documentsHelpCurrent':
    'Os documentos escolhidos são acrescentados à atividade. Os documentos que ela já tem são mantidos.',
  'updateChildServiceOrder.with': 'com os dados ',
  'updateChildServiceOrder.description': 'Descrição',
  'updateChildServiceOrder.place': 'Local',
  'updateChildServiceOrder.scheduling': 'Data de agendamento',
  'updateChildServiceOrder.checklists': 'Quais atividades filhas atualizar',
  'updateChildServiceOrder.checklistsHelp':
    'Aplica-se à atividade filha vinculada ao questionário escolhido. Se a atividade tiver apenas uma atividade filha vinculada, este campo pode ficar em branco (ela é usada automaticamente); só é necessário quando houver mais de uma.',
  'updateChildServiceOrder.name': 'Nome',
  'updateChildServiceOrder.user': 'Responsável',
  'updateChildServiceOrder.asset': 'Ativo',
  'updateChildServiceOrder.priority': 'Prioridade',
  'updateChildServiceOrder.address': 'Endereço',
  'updateChildServiceOrder.metadata': 'Metadata',
  'updateChildServiceOrder.tag': 'Tag',
  'updateChildServiceOrder.documents': 'Documentos',
  'updateChildServiceOrder.documentsHelp':
    'Os documentos escolhidos são acrescentados à atividade filha. Os documentos que ela já tem são mantidos.',
  'updateChildServiceOrder.fieldsHelp':
    'Só os campos adicionais preenchidos aqui são atualizados na atividade filha. Os demais campos adicionais dela são mantidos como estão.',
  'updateChildServiceOrder.dependentHelp':
    'Só são atualizadas as atividades filhas vinculadas à atividade pai que dependem dela (a atividade pai fica pendente até a filha ser concluída).'
}
